import { render, staticRenderFns } from "./DataSnapshot.vue?vue&type=template&id=637ec35c&scoped=true&"
import script from "./DataSnapshot.vue?vue&type=script&lang=ts&"
export * from "./DataSnapshot.vue?vue&type=script&lang=ts&"
import style0 from "./DataSnapshot.vue?vue&type=style&index=0&id=637ec35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ec35c",
  null
  
)

export default component.exports